<template>

  <div :class="{ animateIn : !(pagePart.field.key == 'page_builder') }">

    <page-builder-part v-if="pagePart.field.type == 'flexible' && pagePart.field.key == 'page_builder' && pagePart.children"
      :page-part="part" :key="index" v-for="(part, index) of pagePart.children"></page-builder-part>

    <project-intro v-if="pagePart.field.type == 'row' && pagePart.field.key == 'intro_row'" :data="pagePart"></project-intro>

    <large-image v-if="pagePart.field.type == 'row' && pagePart.field.key == 'large_image'" :data="pagePart"></large-image>

    <two-column v-if="pagePart.field.type == 'row' && pagePart.field.key == 'two_column'" :data="pagePart"></two-column>

    <stacked-column v-if="pagePart.field.type == 'row' && pagePart.field.key == 'stacked_column'" :data="pagePart"></stacked-column>

    <project-quote v-if="pagePart.field.type == 'row' && pagePart.field.key == 'quote'" :data="pagePart"></project-quote>

    <project-content v-if="pagePart.field.type == 'row' && pagePart.field.key == 'single_content'" :data="pagePart"></project-content>

    <image-carousel v-if="pagePart.field.type == 'row' && pagePart.field.key == 'image_carousel'" :data="pagePart"></image-carousel>

    <video-block v-if="pagePart.field.type == 'row' && pagePart.field.key == 'video_row'" :data="pagePart"></video-block>


  </div>

</template>

<script>
  export default {
    props: {
      pagePart: [Array, Object]
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/PageBuilderPart/PageBuilderPart.vue